import Select from 'react-select'
import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import Receive from '../reusable/receive'
import DateRangePicker from '../reusable/rangePicker'

import { server, stringifyDate, useListData, usePet, useSocketEvents, useToggle } from '../../modules'
import NewReport from '../drawers/newReport'
import Confirm from '../reusable/confirm'
import { useSelector } from 'react-redux'

const Reports = ({ department, reports: templates, additional = {} }) => {
    const [template, setTemplate] = useState()
    const [selected, setSelected] = useState()
    const [string, setString] = useState('')
    const [ranges, setRanges] = useState()

    const [newReport, toggleNewReport] = useToggle()

    const { user } = useSelector(state => state.application)

    const [
        { loading, error, fetch }, 
        { list: reports }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('reports', ranges ? { string, department, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { string, department }, { notify: true, manual: false })

    const refresh = () => {
        navigate(1)
        fetch()
    }

    useSocketEvents({
        'report-complete': {
            condition: data => data.department === department,
            notif: {
                message: 'Report Status Update',
                type: 'info'
            },
            callback: () => setTimeout(refresh, 300)
        }
    })

    const search = str => {
        setString(str)
        refresh()
    }

    const changeTemplate = temp => {
        setTemplate(temp)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    } 

    const onComplete = ({ data }, notif, ops) => {
        refresh()
        notif('Report has been deleted.', ops('success'))
    }
    
    const [, execute] = usePet('deleteReport', {
        id: selected
    }, { notify: true, callback: onComplete, manual: true })

    const deleteReport = id => {
        setSelected(id)
        execute()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {
                newReport &&
                <NewReport
                    onPerform={ refresh }
                    reports={ templates }
                    visible={ newReport }
                    additional={ additional }
                    toggle={ toggleNewReport } />
            } 
            <div className="w-full mx-auto">
                <div className="flex justify-between items-center mb-8">
                    <input
                        onChange={e => search(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-inv-item"
                        type="text"
                        placeholder="Type to search items" />
                    <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                        <DateRangePicker
                            ranges={ ranges }
                            selectRange={ selectRange } />
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item onClick={ toggleNewReport }>New Report</Menu.Item>
                                </Menu>
                            }>
                            <button className="btn hisani-btn-green-light ml-2 text-white">
                                <span className="hidden xs:block mr-2">Actions</span>
                                <AiOutlineDown />
                            </button>
                        </Dropdown>
                    </div>
                </div>
                <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header className="px-5 py-4 flex justify-between items-center border-b border-gray-100">
                        <h2 className="font-semibold text-gray-800">Reports</h2>
                        <span className="flex">
                            <Select
                                isClearable
                                value={ template }
                                onChange={ changeTemplate }
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ templates?.map(temp => ({ label: temp?.name, value: temp?._id })) }
                                placeholder="Select Report" />
                            <button onClick={ refresh } className="btn ml-2 py-2.5 hisani-btn-green-light text-white">
                                <AiOutlineReload style={{ color: "white" }} />
                            </button>
                        </span>
                    </header>
                    <div className="p-3 overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                reports.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm text-left">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold">Title</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold">Generated By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold">Generated On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {/* Row */}
                                            {
                                                reports.map((report, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div>{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ report.title }</div>
                                                            <p className="text-gray-500 text-xs italic mb-0">{ report.description.substring(0, 55) }{ report.description.length > 55 ? '...' : '' }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <p className={ `${ report.status === 'Pending' ? 'text-yellow-500' : report.status === 'Completed' ? 'text-green-500' : 'text-red-500' } text-xs italic` }>{ report?.status }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div>{ report?.generatedBy?.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div>{ stringifyDate(report.begunOn) }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => null }>View</Menu.Item>
                                                                        { report?.status === 'Completed' ? <a href={ `${server}/uploads/reports/${ report?.file }` } target="_blank" rel="noopener noreferrer"><Menu.Item>Download Report</Menu.Item></a> : null }
                                                                        {
                                                                            user?.issuperuser &&
                                                                            <Menu.Item onClick={ () => Confirm({
                                                                                title: 'Delete Report',
                                                                                message: 'Are you sure you want to delete this report?',
                                                                                onOk: () => deleteReport(report?._id),
                                                                                okText: "Delete"
                                                                            }) }>Delete</Menu.Item>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please click above to generate a report</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
                {/* <Switch>
                    <Route path={`${path}/history/:id/:store`}>
                        <ItemHistory path={path} onClose={refresh} />
                    </Route>
                </Switch> */}
            </div>
        </div>
    )
}

export default Reports